import { ThemePartial } from "chameleon/lib/components";

import { PlainMessage, Struct, Value } from "frontend-client";

export type ThemeDataType = { [p: string]: string | ThemeDataType };

export function mapUiSettingsToTheme(uiSettings?: PlainMessage<Struct>) {
  if (!uiSettings) return {};

  function mapStructValues(items: { [key: string]: PlainMessage<Value> }) {
    const data: ThemeDataType = {};

    if (items) {
      Object.entries(items).forEach((item: [string, PlainMessage<Value>]) => {
        if (item[1].kind.case === "structValue") {
          data[item[0]] = mapStructValues(item[1].kind.value?.fields);
        } else {
          data[item[0]] = item[1].kind.value as string | ThemeDataType;
        }
      });
    }
    return data;
  }

  return mapStructValues(uiSettings.fields) as ThemePartial;
}
